export default {
  'setVariable.title': 'Establecer Variables',

  'setVariable.form.sourceForm': 'Formulario Origen',
  'setVariable.form.sourceField': 'Campo Origen',
  'setVariable.form.formFieldValueSource': 'Origen Valor Campo',
  'setVariable.form.variable': 'Variable',

  'setVariable.form.valueSource': 'Origen Valor',
  'setVariable.form.valueDestination': 'Valor Destino',
  'setVariable.form.sourceVariable': 'Variable Origen',
  'setVariable.form.destinationDynamicEntity': 'Entidad Destino',
  'setVariable.form.destinationDynamicEntityField': 'Campo de Entidad Destino',
  'setVariable.form.form': 'Formulario',
  'setVariable.form.field': 'Campo',
  'setVariable.form.formula': 'Formula',
  'setVariable.form.fixedValue': 'Valor Fijo',
  'setVariable.form.internalField': 'Campo Interno',

  'setVariable.form.parameterValueFilterComparisonOperator': 'Operador para Filtro',
  'setVariable.form.parameterValueFilter': 'Valor Filtro Parámetro',

  'setVariable.form.formFieldValueDestination': 'Destino Valor Campo',

  'setVariable.form.tableParameterName': 'Nombre Parámetro Lista',
  'setVariable.form.parameterName': 'Nombre Parámetro',
  'setVariable.form.attachmentFileName': 'Nombre del Adjunto',
  'setVariable.form.attachmentContentType': 'Tipo de Contenido',

  'setVariable.form.select.FormField': 'Formulario / Campo',
  'setVariable.form.select.Variable': 'Variable',
  'setVariable.form.select.EntityField': 'Campo de Entidad',

  'setVariable.form.select.Formula': 'Formula',
  'setVariable.form.select.FixedValue': 'Valor Fijo',
  'setVariable.form.select.InternalField': 'Campo Interno',
  'setVariable.form.select.IterationStepData': 'Iteración / Datos',
  'setVariable.form.select.GeneratedDocument': 'Documento Generado',

  'setVariable.form.select.FieldValue': 'Valor a Mostrar',
  'setVariable.form.select.FieldSearchValue': 'Valor de Búsqueda',

  'setVariable.form.select.ProcessIdentifier': 'Proceso - Identificador Interno',
  'setVariable.form.select.ProcessName': 'Proceso - Nombre',
  'setVariable.form.select.ProcessGroupName': 'Grupo de Proceso - Nombre',
  'setVariable.form.select.InstanceName': 'Solicitud - Nombre',
  'setVariable.form.select.InstanceCreated': 'Solicitud - Fecha de Creación',
  'setVariable.form.select.InstanceStatus': 'Solicitud - Estado',
  'setVariable.form.select.ApplicantFullName': 'Solicitante - Nombre Completo',
  'setVariable.form.select.InstanceApprovedDate': 'Solicitud - Fecha de Aprobación',
  'setVariable.form.select.InstanceRejectedDate': 'Solicitud - Fecha de Rechazo',
  'setVariable.form.select.ApplicantNames': 'Solicitante - Nombres',
  'setVariable.form.select.ApplicantLastNames': 'Solicitante - Apellidos',
  'setVariable.form.select.ApplicantEmail': 'Solicitante - Correo',
  'setVariable.form.select.ApplicantPosition': 'Solicitante - Puesto',
  'setVariable.form.select.InstanceIdentifier': 'Solicitud - Identificador Interno',
  'setVariable.form.select.InstanceLastInstanceRejectUsers':
    'Solicitud - Usuarios Rechazadores Último Paso',
  'setVariable.form.select.InstanceLastInstanceApproversUsers':
    'Solicitud - Usuarios Aprobadores Último Paso',
  'setVariable.form.select.InstanceRejectedReason': 'Solicitud - Motivo Rechazo',
  'setVariable.form.select.InstanceApprovalRemarks': 'Solicitud - Observaciones Aprobación',
  'setVariable.form.select.InstanceCancellationDate': 'Solicitud - Fecha de Cancelación',
  'setVariable.form.select.InstanceCancellationReason': 'Solicitud - Motivo de Cancelación',
  'setVariable.form.select.InstanceDetailsViewUrl': 'Solicitud - Url Vista Detalles',

  'setVariable.form.sourceDocumentTemplate': 'Plantilla Documento Origen',

  'setVariable.mapping': 'Mapeo',
  'setVariable.addMapping': 'Agregar mapeo',
  'setVariable.noMappings': 'No hay mapeos configurados.',
};
